import { IntervalUnit } from '@/proto/logiblocks/logiblocks';

/** Seconds in one of the unit; anything but SECONDS and HOURS counts as minutes. */
export function secondsPerUnit(unit: IntervalUnit): number {
  if (unit === IntervalUnit.HOURS) return 3600;
  if (unit === IntervalUnit.SECONDS) return 1;
  return 60;
}

/**
 * Converts an amount in the given unit (SECONDS, MINUTES or HOURS) to whole seconds.
 * dateTimeUtils' durationToSeconds predates SECONDS and reads it as minutes.
 */
export function amountToSeconds(amount: number, unit: IntervalUnit): number {
  return Math.round(amount * secondsPerUnit(unit));
}

/** Converts a number of seconds to an amount in the given unit. */
export function secondsToAmount(seconds: number, unit: IntervalUnit): number {
  return seconds / secondsPerUnit(unit);
}
